import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export function Checklist({
	items,
	className,
}: {
	items: string[];
	className?: string;
}) {
	return (
		<ul className={cn("space-y-3", className)}>
			{items.map((item) => (
				<li key={item} className="flex gap-3">
					<span
						aria-hidden="true"
						className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-full border border-signal/40 bg-signal/10"
					>
						<Check className="size-3 text-signal-ink" strokeWidth={2.5} />
					</span>
					<span className="text-pretty">{item}</span>
				</li>
			))}
		</ul>
	);
}
